// Jurisdictions
export const ADD_JURISDICTION_TO_TEAM = 'ADD_JURISDICTION_TO_TEAM';
export const ADD_JURISDICTION_TO_TEAM_SUCCESS =
    'ADD_JURISDICTION_TO_TEAM_SUCCESS';
export const ADD_JURISDICTION_TO_TEAM_FAIL = 'ADD_JURISDICTION_TO_TEAM_FAIL';

export const DELETE_JURISDICTION_FROM_TEAM = 'DELETE_JURISDICTION_FROM_TEAM';
export const DELETE_JURISDICTION_FROM_TEAM_SUCCESS =
    'DELETE_JURISDICTION_FROM_TEAM_SUCCESS';
export const DELETE_JURISDICTION_FROM_TEAM_FAIL =
    'DELETE_JURISDICTION_FROM_TEAM_FAIL';

// Brands
export const ADD_BRAND_TO_TEAM = 'ADD_BRAND_TO_TEAM';
export const ADD_BRAND_TO_TEAM_SUCCESS = 'ADD_BRAND_TO_TEAM_SUCCESS';
export const ADD_BRAND_TO_TEAM_FAIL = 'ADD_BRAND_TO_TEAM_FAIL';

export const DELETE_BRAND_FROM_TEAM = 'DELETE_BRAND_FROM_TEAM';
export const DELETE_BRAND_FROM_TEAM_SUCCESS = 'DELETE_BRAND_FROM_TEAM_SUCCESS';
export const DELETE_BRAND_FROM_TEAM_FAIL = 'DELETE_BRAND_FROM_TEAM_FAIL';
